<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div
    data-slot="alert-description"
    :class="
      cn(
        'space-y-2 group-has-[>svg]/alert:col-start-2 group-data-[size=sm]/alert:space-y-1 [[data-slot=alert-title]+&]:mt-2',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>
